export default class SurveyQuestionsService {
  constructor(httpClient) {
    this.http = httpClient;
  }

  // 모든 설문 질문 조회 (공통)
  async findAllSurveyQuestionsAll(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/surveyquestions/readall?${queryParams}`, {
      method: "GET",
    });
  }

  // 공통 설문 질문 조회
  async findAllSurveyQuestions(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/surveyquestions/readallcommon?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  // 과목별 설문 질문 조회 (나중에 사용)
  async findSurveyQuestionsBySubject(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/surveyquestions/readallbysubject?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  // 설문 질문 생성
  async createSurveyQuestion(data) {
    return this.http.fetch("/api/surveyquestions/create", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 설문 질문 수정
  async updateSurveyQuestion(data) {
    return this.http.fetch("/api/surveyquestions/update", {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  // 설문 질문 배치 생성/수정 (id가 있으면 수정, 없으면 생성)
  async createOrUpdateSurveyQuestions(data) {
    return this.http.fetch("/api/surveyquestions/createorupdatebulk", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  // 설문 질문 삭제
  async deleteSurveyQuestion(id) {
    return this.http.fetch("/api/surveyquestions/delete", {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }

  // 질문에 응답이 있는지 확인
  async checkQuestionHasAnswers(questionId) {
    return this.http.fetch(`/api/surveyquestions/checkanswers/${questionId}`, {
      method: "GET",
    });
  }
}
